module.exports = __webpack_public_path__ + "img/product_66.3fbe440.webp";